/*
 *   Copyright (c) 2025 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 */
import { Button, Modal } from "antd"
import * as React from "react"
import { FaSearch } from "react-icons/fa"
import theme from "../styles/theme"
import LabelWithTooltip from "./LabelWithTooltip"
import Search from "./search"

const SearchModal = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [resetKey, setResetKey] = React.useState(0)

  const showModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    // Reset filters by remounting the Search component
    setResetKey(prev => prev + 1)
  }

  return (
    <>
      <Button
        type="primary"
        icon={<FaSearch />}
        style={{
          color: theme.colorBgBase,
        }}
        variant="solid"
        onClick={() => showModal()}
      >
        <span>Search</span>
      </Button>
      <Modal
        title={
          <LabelWithTooltip
            label="Search for an inventory resource"
            tooltip="Search by title, description, resource type, topics, or stakeholders"
          />
        }
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        centered
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "50%",
          xxl: "40%",
        }}
      >
        <Search key={resetKey} elementOnClick={closeModal} />
      </Modal>
    </>
  )
}

export default SearchModal
